import TradeArrow from '../src/TradeArrow';
export default TradeArrow;
